// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RedebitPaymentStatusModel from '../../model/redebit-payment-status-model';
import RedebitPaymentStatusDTO from '../dto/redebit-payment-status-dto';
import dtoSchema from '../schemas/redebit-payment-status-schema';

export default abstract class RedebitPaymentStatusModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RedebitPaymentStatusDTO>) {
    super();
    if (data) {
      this.status = data.status ?? undefined;
    }
  }
  /**
  */
  status?: string;

  static toModel(dto: DeepPartial<RedebitPaymentStatusDTO>): RedebitPaymentStatusModel;
  static toModel(dto: DeepPartial<RedebitPaymentStatusDTO> | undefined | null): RedebitPaymentStatusModel | undefined;
  static toModel(dto: DeepPartial<RedebitPaymentStatusDTO> | undefined | null): RedebitPaymentStatusModel | undefined {
    return dto ? new RedebitPaymentStatusModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RedebitPaymentStatusModel> | RedebitPaymentStatusModel): RedebitPaymentStatusDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      status: unwrapped.status,
    } as RedebitPaymentStatusDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RedebitPaymentStatusModel, can not map to RedebitPaymentStatusDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
